<template>
  <header>
    <h3>¿Cómo deseas crear tu plantilla?</h3>
    <p>Elige como crear tu secuencia.</p>
  </header>

  <!-- @/app/flows/sequences/assets/ -->
  <div class="container__card">
    <a-card class="card-type" @click="selectedType(SequenceType.Multichannel)">
      <img class="icon" :src="urlImage('SequenceMultichannel.svg')" alt="multichannel" />
      <div>
        <p class="title">{{ SequenceTypeText[SequenceType.Multichannel] }}</p>
        <p class="description">
          Utiliza canales como SMS, correo electrónico, llamadas y WhatsApp para contactar a tus
          clientes. Se creará el ticket únicamente si el contacto responde.
        </p>
        <a class="link" :href="`${DOCS_URL}/multicanal`" target="_blank" rel="noopener noreferrer" @click.stop>
          Más información
          <IconExternalLink active />
        </a>
      </div>
    </a-card>
    <a-card class="card-type" @click="selectedType(SequenceType.AutomaticProgressive)">
      <img class="icon" :src="urlImage('AutomaticProgressive.svg')" alt="progressive" />
      <div>
        <p class="title">{{ SequenceTypeText[SequenceType.AutomaticProgressive] }}</p>
        <p class="description">
          Utiliza una llamada de tipo progresivo. Este tipo de secuencia crea un ticket
          automáticamente en el sistema apenas se intenta contactar al cliente.
        </p>
        <a class="link" :href="`${DOCS_URL}/progresivo-automatico`" target="_blank" rel="noopener noreferrer" @click.stop>
          Más información
          <IconExternalLink active />
        </a>
      </div>
    </a-card>
  </div>
</template>

<script setup lang="ts">
import { SequenceType, SequenceTypeText } from "@/app/flows/sequences/utils/enums";
import IconExternalLink from "@/app/common/components/atoms/IconExternalLink.vue";

const DOCS_URL = `${import.meta.env.VITE_WEB_DOC}/flujos/secuencias`;

const emit = defineEmits<{
  selectedType: [type: number];
}>();

const selectedType = (type: number) => {
  emit("selectedType", type);
};

const urlImage = (image: string) => {
  return new URL(`../../assets/${image}`, import.meta.url).href;
};
</script>

<style scoped lang="sass">
h3
  color: $gray-9
  font-size: 20px
  margin-bottom: 16px

h4
  color: $gray-9
  font-size: 14px
  margin-bottom: 16px
  font-weight: 600

.divider
  background-color: $gray-6

header
  width: 100%
  text-align: center
  margin-bottom: 25px

  p
    color: $text-secondary
    margin: 0
    font-size: 16px

.container
  &__card
    display: flex
    justify-content: space-between
    margin: 80px 14px
    .card-type
      width: 49%
      text-align: center
      cursor: pointer
      margin: 10px
      padding: 18px
    .icon
      height: 96px
    .title
      font-weight: 600
      font-size: 14px
      line-height: 22px
      margin: 10px 0 20px
    .description
      font-size: 12px
      line-height: 20px
      height: 100px
      margin-bottom: 16px
    .link
      display: inline-flex
      align-items: center
      gap: 4px
      margin-bottom: 10px
      font-size: 12px

      :deep(svg)
        width: 14px
        height: auto
</style>
